import { Text } from '@amzn/meridian';
import type { ContentTableContentProps } from 'features/traffic/campaigns/campaign-configs/types';
import { SummaryTableWrapper } from 'features/traffic/campaigns/TPCampaignSummary/components/SummaryTableWrapper';
import type { FC } from 'react';
import type { TGlobalContent } from '../types';

/**
 * ContentTableContent component for config-driven campaigns.
 *
 * Note: Content summary functionality was removed due to:
 * 1. UX decision to prioritize other features with higher user impact
 * 2. Users are not currently relying on the summary feature
 * 3. High level of effort to implement complete summary section,
 *     including custom logic for schema resolution and UI ordering
 */
export const ContentTableContent: FC<ContentTableContentProps<TGlobalContent>> = () => (
  <SummaryTableWrapper>
    <Text alignment="left">Content summary not available for this campaign type</Text>
  </SummaryTableWrapper>
);
